import { graphql } from "relay-runtime"

export const chEpisodeOfCareFragment = graphql`
  fragment chEpisodeOfCareFragment on ch_EpisodeOfCare {
    id
    isVirtual
    icdDiagnosis {
      id
      isAssociation
      diagnosisCode
      primaryCode
      secondaryCode
      associationType
      text
    }
    patientId
    createdBy
    createdAt
    updatedAt
    isUpdatable
    progressNotes(first: null) @connection(key: "EpisodeOfCareProgressNotesConnection_progressNotes") {
      edges {
        node {
          ...chProgressNoteFragment @relay(mask: false)
          ...chProgressNoteFragment
        }
      }
    }
    relatedConditions {
      id
      icdDiagnosis {
        id
        isAssociation
        diagnosisCode
        primaryCode
        secondaryCode
        associationType
        text
      }
    }
  }
`
